import { render, staticRenderFns } from "./BridgeIframe.vue?vue&type=template&id=394097cb&scoped=true"
import script from "./BridgeIframe.vue?vue&type=script&lang=js"
export * from "./BridgeIframe.vue?vue&type=script&lang=js"
import style0 from "./BridgeIframe.vue?vue&type=style&index=0&id=394097cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394097cb",
  null
  
)

export default component.exports